import { toAppDateTime } from '@macs-frontend/core/utils/datetime';
import {
  FeeGroup,
  FeeGroupStatuses,
} from '@macs-frontend/features/shared/models/fee-group.model';
import { Fee } from '@macs-frontend/features/shared/models/fee.model';
import { box } from 'ngrx-forms';
import { Expense, ProjectTask, Task } from '..';
import { ExpenseGroup } from '../../company-management/manage/models/expense-group';
import { ExpenseStatuses } from '../models/expense';
import { InvoiceItemForm, InvoiceItemTypes } from '../models/invoice-item.model';
import { InvoiceItems } from '../models/invoice.model';
import { ProjectExpense } from '../models/project';
import { TaskGroup } from '../models/task-group.model';
import { TaskStatuses } from '../models/task.model';
import {
  DictionaryTransport,
  TeamCostTeamType,
} from '@macs-frontend/features/company-management/team-cost/team-cost.types';

export const emptyTask: Task = {
  // @ts-expect-error
  uuid: null,
  status: TaskStatuses.ACTIVE,
  taskGroups: [],
  // @ts-expect-error
  description: null,
  defaultBillable: false,
  // @ts-expect-error
  defaultHourlyRate: null,
  defaultTask: false,
};

export const emptyProjectTask: ProjectTask = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  originalTask: null,
  billable: false,
  billingRatePerHour: 0,
  budgetFee: 0,
  budgetHours: 0,
  approvedBudgetHours: 0,
  description: '',
  projectLevelTask: false,
  esimateLabel: '',
  projectTaskAssignments: [],
};

export const emptyExpense: Expense = {
  uuid: null,
  name: '',
  expenseUnitPrice: null,
  status: ExpenseStatuses.ACTIVE,
  billableRate: null,
  expenseGroups: [],
  description: null,
  groupByType: null,
};

export const emptyFee: Fee = {
  // @ts-expect-error
  uuid: null,
  name: '',
  description: null,
};

export const emptyTeamType: TeamCostTeamType = {
  // @ts-expect-error
  uuid: null,
  name: '',
};

export const emptyTransport: DictionaryTransport = {
  // @ts-expect-error
  uuid: null,
  name: '',
};

export const emptyExpenseGroup: ExpenseGroup = {
  uuid: null,
  name: '',
  expenseUnitPrice: null,
  billableRate: null,
  expenses: [],
  type: {
    uuid: null,
    name: null,
  },
  description: '',
  groupByType: '',
  status: ExpenseStatuses.ACTIVE,
};

export const emptyTaskGroup: TaskGroup = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  tasks: [],
  type: {
    // @ts-expect-error
    uuid: null,
    // @ts-expect-error
    name: null,
  },
  // @ts-expect-error
  description: null,
  // @ts-expect-error
  groupByType: null,
  status: TaskStatuses.ACTIVE,
  task: emptyTask,
};

export const emptyFeeGroup: FeeGroup = {
  // @ts-expect-error
  uuid: null,
  name: '',
  fees: [],
  status: FeeGroupStatuses.ACTIVE,
};

export const emptyProjectExpense: ProjectExpense = {
  uuid: null,
  // @ts-expect-error
  expenseGroup: null,
  // @ts-expect-error
  description: null,
  // @ts-expect-error
  expenseUnitPrice: null,
  // @ts-expect-error
  billableRate: null,
  originalExpense: emptyExpense,
  // @ts-expect-error
  project: null,
  isBillable: false,
};

export const emptyFinancialItem: Omit<InvoiceItemForm, 'uuid'> = {
  name: '',
  description: '',
  amount: null,
  unitPrice: 1,
  billablePrice: 1,
  billablePriceMargin: 0,
  quantity: 1,
  discount: null,
  type: InvoiceItems.INVOICE_ITEM,
  tax: null,
  project: box(null),
  projectId: null,
  expense: box(emptyExpense),
  task: box(emptyTask),
  projectTask: box(null),
  itemType: InvoiceItemTypes.Task,
  qty1: 1,
  qty2: 1,
  qty1Type: box(null),
  qty2Type: box(null),
  feeSources: [],
  globalFee: true,
  fee: box(null),
  teamType: box(null),
  transport: box(null),
  itemTransport: box(null),
  createdAt: toAppDateTime(new Date()),
  invoice: box(null),
  invoiceGroup: box(null),
  partiallySelected: false,
  sequence: 0,
  SPONumbers: box([]),
  SPOUnitPrice: 0,
  color: '',
  spoAmount: 0,
  spoQty1: 0,
  spoQty2: 0,
  inCalc: true,
  isVisibleForCustomer: true,
  teamCost: box(null),
  originalInvoiceGroup: null,
  taxRate: box(null),
};
